// extracted by mini-css-extract-plugin
module.exports = {"ExpensesHighlights":"Home_ExpensesHighlights__1-VV1"};